<app-dialog-base applyCaption="Yes" title="Remove draft" modalId="removeDraftConfirmModal" [itemTemplate]="removeTemplate" (modalApply)="apply()" (modelCancel)="cancel()"></app-dialog-base>

<ng-template #removeTemplate>
    <div class="sdds-banner">
        <div class="sdds-banner-body">
            Are you sure to remove your draft?
        </div>
    </div>
</ng-template>